// extracted by mini-css-extract-plugin
export default {"IconButton":"add-column-header-module__IconButton--cb0UJ"};